import { InvoiceTableState } from './invoice-table.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    invoiceTableChangePage,
    invoiceTableChangeQuery,
    invoiceTableFailure, invoiceTableMasterToggle,
    invoiceTableRequest, invoiceTableSetSelection, invoiceTableSort,
    invoiceTableSuccess, invoiceTableToggle
} from './invoice-table.actions';

const initialState: InvoiceTableState = {
    query: {
        sortColumn: 'date',
        sortDescending: true,
        reference: null,
        dateAfter: null,
        dateBefore: null,
        pageNumber: 1,
        itemsPerPage: 25
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(invoiceTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(invoiceTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(invoiceTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true
    })),
    on(invoiceTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(invoiceTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(invoiceTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(invoiceTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(invoiceTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(invoiceTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    }))
);

export function invoiceTableReducer(state: InvoiceTableState | undefined, action: Action): any {
    return reducer(state, action);
}
